// Markdown Parser
// 將 Markdown 文本轉換為 HTML，供 Tiptap 編輯器使用

export function parseMarkdownToHTML(markdown) {
  if (!markdown || markdown.trim() === '') {
    return '<p></p>'
  }

  // 分割段落（以雙換行或單換行分隔）
  const lines = markdown.split('\n')
  const result = []
  let i = 0

  while (i < lines.length) {
    const line = lines[i]

    // 跳過空行
    if (!line.trim()) {
      i++
      continue
    }

    // 程式碼區塊 (```)
    if (line.trim().startsWith('```')) {
      const codeLines = []
      i++ // 跳過開始的 ```
      while (i < lines.length && !lines[i].trim().startsWith('```')) {
        codeLines.push(lines[i])
        i++
      }
      i++ // 跳過結束的 ```
      result.push(`<pre><code>${escapeHtml(codeLines.join('\n'))}</code></pre>`)
      continue
    }

    // 標題 (# ## ### ####)，允許空標題
    const headingMatch = line.match(/^(#{1,6})(\s+(.*))?$/)
    if (headingMatch) {
      const level = headingMatch[1].length
      const text = headingMatch[3] ? processInline(headingMatch[3]) : ''
      result.push(`<h${level}>${text}</h${level}>`)
      i++
      continue
    }

    // 分隔線 (--- 或 ___ 或 ***)
    if (line.match(/^(\-{3,}|_{3,}|\*{3,})$/)) {
      result.push('<hr>')
      i++
      continue
    }

    // 引用區塊 (> text)
    if (line.trim().startsWith('>')) {
      const quoteLines = []
      while (i < lines.length && lines[i].trim().startsWith('>')) {
        quoteLines.push(lines[i].trim().substring(1).trim())
        i++
      }
      result.push(`<blockquote><p>${processInline(quoteLines.join(' '))}</p></blockquote>`)
      continue
    }

    // 無序列表 (- item 或 * item 或 + item)
    if (line.match(/^\s*[-*+]\s+/)) {
      const listItems = []
      while (i < lines.length && lines[i].match(/^\s*[-*+]\s+/)) {
        const itemMatch = lines[i].match(/^\s*[-*+]\s+(.+)$/)
        if (itemMatch) {
          listItems.push(`<li>${processInline(itemMatch[1])}</li>`)
        }
        i++
      }
      result.push(`<ul>${listItems.join('')}</ul>`)
      continue
    }

    // 有序列表 (1. item)
    if (line.match(/^\s*\d+\.\s+/)) {
      const listItems = []
      while (i < lines.length && lines[i].match(/^\s*\d+\.\s+/)) {
        const itemMatch = lines[i].match(/^\s*\d+\.\s+(.+)$/)
        if (itemMatch) {
          listItems.push(`<li>${processInline(itemMatch[1])}</li>`)
        }
        i++
      }
      result.push(`<ol>${listItems.join('')}</ol>`)
      continue
    }

    // 待辦列表 (- [ ] task 或 - [x] task)
    if (line.match(/^\s*[-*+]\s+\[([ xX])\]\s+/)) {
      const listItems = []
      while (i < lines.length && lines[i].match(/^\s*[-*+]\s+\[([ xX])\]\s+/)) {
        const itemMatch = lines[i].match(/^\s*[-*+]\s+\[([ xX])\]\s+(.+)$/)
        if (itemMatch) {
          const checked = itemMatch[1].toLowerCase() === 'x'
          listItems.push(`<li data-type="taskItem" data-checked="${checked}"><label><input type="checkbox" ${checked ? 'checked' : ''}><span></span></label><div><p>${processInline(itemMatch[2])}</p></div></li>`)
        }
        i++
      }
      result.push(`<ul data-type="taskList">${listItems.join('')}</ul>`)
      continue
    }

    // 普通段落
    const paragraphLines = []
    const startI = i
    while (i < lines.length && lines[i].trim() && !isSpecialLine(lines[i])) {
      paragraphLines.push(lines[i])
      i++
    }
    if (paragraphLines.length > 0) {
      result.push(`<p>${processInline(paragraphLines.join(' '))}</p>`)
    }

    // 防止無限循環：如果沒有處理任何內容，跳過當前行
    if (i === startI) {
      i++
    }
  }

  return result.join('')
}

// 檢查是否為特殊行（標題、列表等）
function isSpecialLine(line) {
  return line.match(/^(#{1,6}\s+|>\s+|[-*+]\s+|\d+\.\s+|```|---$|___$|\*\*\*$)/)
}

// 處理行內格式
function processInline(text) {
  return text
    // 粗體 + 斜體 (***text***)
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    // 粗體 (**text**)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    // 斜體 (*text*)
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    // 刪除線 (~~text~~)
    .replace(/~~(.+?)~~/g, '<s>$1</s>')
    // 行內程式碼 (`code`)
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    // 連結 ([text](url))
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
}

// 轉義 HTML 特殊字符（用於程式碼區塊）
function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}
